import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class AISummaryModel extends BaseModel {
  static urlPath = "ai/call_summary";

  @attr("string") uuid;
  @attr("string") caseId;
  @belongsTo("client") user;
  @belongsTo("case-call-log") callLog;
  @attr("string") clientName;
  @attr("json") content;
  @attr("json") recording;
  @attr("string") seenTime;
  @attr("string") readTime;
}
